export default __webpack_public_path__ + "static/media/tempel view (1)@2x.64256ae6.webp";